import { render, staticRenderFns } from "./JiwaSummary.vue?vue&type=template&id=2064174f"
import script from "./JiwaSummary.vue?vue&type=script&lang=js"
export * from "./JiwaSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports